import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col" };
const _hoisted_2 = {
    key: 0,
    class: "flex flex-row justify-between items-center"
};
const _hoisted_3 = ["for"];
const _hoisted_4 = ["id", "value", "placeholder", "maxlength", "rows", "disabled"];
import { v4 } from 'uuid';
import { InputTextHelper } from '@/lib/components/Helper';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseTextarea',
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        maxLength: {
            type: String,
            default: null
        },
        rows: {
            type: Number,
            default: 5
        },
        disabled: {
            type: Boolean,
            default: false
        },
        hoverBorder: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        isOptional: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: null
        },
        instructions: {
            type: String,
            default: null
        }
    },
    emits: ["update:modelValue", "change"],
    setup(__props) {
        const id = v4();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.label && __props.label.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("label", {
                            for: _unref(id),
                            class: _normalizeClass(["inline-block text-base font-medium mb-3 whitespace-pre-line", { 'text-transparent bg-gray-200 rounded-lg h-5': __props.loading }])
                        }, _toDisplayString(__props.label), 11, _hoisted_3),
                        (__props.isOptional)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["text-xs font-medium", __props.loading ? 'text-transparent bg-gray-200 rounded-lg' : 'text-gray-500'])
                            }, _toDisplayString(_ctx.$t('platform.common.optional')), 3))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("textarea", _mergeProps({
                    id: _unref(id),
                    value: __props.loading ? '' : __props.modelValue,
                    placeholder: __props.loading ? '' : __props.placeholder,
                    maxlength: __props.maxLength,
                    rows: __props.rows,
                    disabled: __props.disabled || __props.loading,
                    class: ["w-full p-4 rounded border shadow", {
                            'text-gray-600 bg-gray-50': __props.disabled && !__props.hoverBorder,
                            'hover:border-gray-500 text-gray-600 bg-gray-50 border-transparent': __props.disabled && __props.hoverBorder,
                            'text-gray-400': __props.modelValue === '',
                            'border-danger-700 hover:border-danger-700 focus:border-danger-700 focus:outline-none': __props.error
                        }],
                    style: { "resize": "none" }
                }, _ctx.$attrs, {
                    onInput: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', $event.target.value))),
                    onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('change', $event.target.value)))
                }), null, 16, _hoisted_4),
                _createVNode(_unref(InputTextHelper), {
                    error: __props.error,
                    description: __props.instructions
                }, null, 8, ["error", "description"])
            ]));
        };
    }
});
